Librarian.Modules.FavoritesLinks = new Class({
    Extends: Librarian.Modules.Module,
    Binds: ["viewAll"],

    options: {
        classPrefix: "modules-favoriteslinks-",
        label: null
    },

    initialize: function(options, wrapperEl) {
        this.setOptions(options);
        this.parent(this.options, wrapperEl);
    },

    load: function() {
        var self = this;

        if (!this.wrapperEl) {
            return;
        }

        this.parent();
        
        this.request = new Librarian.Request.JSON({
            url: Librarian.path.getMethodUrl("getvpcc") + "&cid=0&out=ljson",
            method: "get",
            onSuccess: function (response) {
                if (self.options.isSquare) {
                    // add view all button
                    new Element("span", {
                        "class": "viewAll",
                        events: {
                            click: function (event) {
                                self.viewAll(event, response)
                            }
                        },
                        text: "View all >"
                    }).injectInside(self.wrapperEl);
                }
                response.presentations.forEach(function(presentation) {
                    var linkEl = new Element("div", {
                        "class": "file-link",
                        events: {
                            click: function(event) {
                                self.clickHandler(event, presentation);
                            }
                        }
                    }).injectInside(self.containerEl);

                    new Element("img", {
                        "class": "file-link-icon",
                        src: "/webclient/_layouts/filetypeicons/Favorites_Icon_16.png"
                    }).injectInside(linkEl);

                    new Element("span", {
                        "class": "file-link-text",
                        text: presentation.name,
                        title: presentation.name
                    }).injectInside(linkEl);
                });
            }
        });
        this.request.send();   
    }, 

    clickHandler: function (event, file) {
        event.stopPropagation();
        Librarian.PreviewWindow.openPreviewWindow(file);
    },

    viewAll: function (event, response) {

            Librarian.Homepage.hide();
            if (Librarian.features.mountedVuePages.load)
                Librarian.Modules.MountedVuePage.hide();

            tileList.loadFromArray(response.presentations);

            var itemEl = $("pageheader");
            if (itemEl) {
                itemEl.show();
            }

            if(Librarian.pageheader != null) {
                Librarian.pageHeader.destroy();
                Librarian.pageHeader = null;
            }

            $('myInProgress').empty();

            Librarian.pageHeader = new Librarian.PageHeader({
                name: "My Favorites",
                showHeaderMenu: false
            });
    }
});